import { useSearchParams } from "react-router-dom";

/**
 * The record open in a view modal, kept in the URL (`?session=`, `?order=`) so a
 * link to it is shareable and the back button closes it. Opening pushes a history
 * entry; closing replaces it, so Back after a close does not reopen the panel.
 * Every other parameter — filters, page — is carried through untouched.
 */
export function useViewParam(key: string): readonly [string, (id: string) => void] {
  const [params, setParams] = useSearchParams();
  const viewing = params.get(key) ?? "";

  function setViewing(id: string) {
    const next = new URLSearchParams(params);
    if (id === "") next.delete(key);
    else next.set(key, id);
    setParams(next, { replace: id === "" });
  }

  return [viewing, setViewing];
}
